<template>
  <div id="app" class="app">
    <div v-if="width >=1200" ref="viewBox" :class="logo ? 'viewBoxs' : 'viewBox'">
      <div style="width:1440px;display: flex;justify-content: space-between;margin: 0 auto;">
        <div class="logo">
          <img v-if="logo" alt src="./assets/img/logoGreen.png"/>
          <img v-else alt src="./assets/img/toplogo.png"/>
        </div>
        <!-- <el-menu
            v-if="width >= 1200"
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
            >
            <el-menu-item
                v-for="(mitem, mindex) in menuList"
                :key="mindex"
                :index="mitem.index"
                ref="menu"
            >
                <el-dropdown @command="onClick(mitem)" v-if="mitem.menu" trigger="hover">
                    <span class="el-dropdown-link" v-text="mitem.menuItem"></span> -->
        <!-- <el-dropdown-menu slot="dropdown" style="width:99.2%;box-sizing: border-box;background: #EEF5F6;">
            <el-container v-for="(items, index) in mitem.menu" :key="index">
            <el-main style="text-align:right">
                <el-dropdown-item
                    v-for="(a, aindex) in items.dropdownItem"
                    :key="aindex"
                    :style="{ width: mitem.menuItem == '首页' ? '65%' : mitem.menuItem == '走进瑞阳心语' ? '70%' : mitem.menuItem == '服务体系' ? '78%' : mitem.menuItem == '产业体系' ? '80%' : mitem.menuItem == '业务体系' ? '90%' : '90.5%' }"
                    @click.native="commidClick(a)"
                    v-text="a.title"
                ></el-dropdown-item>
            </el-main>
            </el-container>
        </el-dropdown-menu> -->
        <!-- </el-dropdown>
    </el-menu-item>
</el-menu> -->
        <el-menu
            :default-active="defaultActive"
            :router="router"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/news">走进瑞阳心语</el-menu-item>
          <el-menu-item index="/product">服务体系</el-menu-item>
          <el-menu-item index="/case">产业体系</el-menu-item>
          <el-menu-item index="/goin">业务体系</el-menu-item>
          <el-menu-item index="/download" style="margin: 0 0 0 40px !important;" >
            心闻资讯
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <!-- 移动端 -->
    <div v-else>
      <div class="sviewBox">
        <img v-if="logo" alt src="./assets/img/logoGreen.png"/>
        <img v-else alt src="./assets/img/toplogo.png"/>
        <img id="clickQuery" alt="" class="img" src="./assets/move/header.png"
             style="width:24px;height:24px;z-index:999" @click="menuClick">
        <!-- <img v-if="logo == false" class="img" @click="menuClick" src="../src/assets/move/head.png" alt=""> -->
        <div v-if="menuShow == true" style="position:absolute;top:50px;right:20px;z-index:9999">
          <el-menu
              :default-active="defaultActive"
              :router="router"
              class="el-menu-demo"
              mode="horizontal"
              style="width:120px"
              @select="handleSelectMove"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/news">走进瑞阳心语</el-menu-item>
            <el-menu-item index="/product">服务体系</el-menu-item>
            <el-menu-item index="/case">产业体系</el-menu-item>
            <el-menu-item index="/goin">业务体系</el-menu-item>
            <el-menu-item index="/download">心闻资讯</el-menu-item>
          </el-menu>
        </div>

      </div>

    </div>
    <router-view/>
    <div style="position: fixed;z-index: 999999999;top: 60%;right: 0%">
<!--      <el-button v-show="!show3" circle icon="el-icon-user-solid" type="primary" @click="handleClick"></el-button>-->
      <div v-if="width >=1200" v-show="!show3" class="imgcontent">
        <img src="./assets/img/logos.png" @click="handleClick">
      </div>
      <div v-else v-show="!show3" class="imgcontents">
        <img src="./assets/img/logos.png" @click="handleClick">
      </div>
      <div v-if="width >=1200" class="customerBoxes" v-show="show3">
        <div style="height: 200px;">
          <div>
            <el-card class="box-card">
              <div v-for="(item,index) in contactList" :key="index" class="imgBox">
                <p style="font-weight:600">{{ item.title }}</p>
                <div style="color: #666666;font-size:14px">{{ item.content }}</div>
              </div>
              <el-button type="text" @click="handleClicks">收起</el-button>
            </el-card>
          </div>
        </div>
      </div>
      <div v-else v-show="show3" class="customerBoxes">
        <div >
          <el-card class="box-card">
            <div v-for="(item,index) in contactList" :key="index" class="imgBox">
              <p style="font-weight:600">{{ item.title }}</p>
              <div style="color: #666666;font-size:14px">{{ item.content }}</div>
            </div>
            <el-button type="text" @click="handleClicks">收起</el-button>
          </el-card>
        </div>
      </div>
    </div>
    <FooterVue></FooterVue>
  </div>
</template>

<script>
import FooterVue from './components/Footer.vue';
import Vue from "vue";
import '@/assets/css/quilEditorFontSize.css'
import {getOssUrl, getSite} from "@/api/api";
import {gsap} from "gsap";

export default {
  components: {
    FooterVue
  },
  data() {
    return {
      contactList: [
        {
          url: require("./assets/img/contacttwo (3).png"),
          title: "公司地址",
          content: "山东省青岛市"
        },
        {
          url: require("./assets/img/contacttwo (1).png"),
          title: "联系电话",
          content: "13041490009"
        },
        {
          url: require("./assets/img/contacttwo (2).png"),
          title: "市场直通热线",
          content: "jki8yo2wsg9@163.com"
        }
      ],
      list: {},
      show3: false,
      menuShow: false,
      router: true,
      defaultActive: this.$route.path,
      isShow: false,
      logo: false,
      drop: false,
      menuList: [
        {
          index: "/",
          menuItem: "首页",
          menu: [
            {
              dropdownItem: [
                {title: "新闻动态", url: "/"},
                {title: "公司简介", url: "/"},
                {title: "公司荣誉", url: "/"},
              ],
            }
          ],
        },
        {
          index: "/news",
          menuItem: "走进瑞阳心语",
          menu: [
            {
              dropdownItem: [
                {title: "公司简介", url: "/news"},
                {title: "公司荣誉", url: "/news"},
                {title: "科研成果", url: "/news"},
                {title: "合作机构", url: "/news"},
                {title: "联系我们", url: "/news"},
              ],
            }
          ],
        },
        {
          index: "/product",
          menuItem: "服务体系",
          menu: [
            {
              dropdownItem: [
                {title: "社会心理服务" + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0', url: "/product"},
                {title: "学校心理服务" + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0', url: "/product"},
                {
                  title: "EAP服务" + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0',
                  url: "/product"
                },
                {title: "社会工作和公益服务", url: "/product"},
              ],
            }
          ],
        },
        {
          index: "/case",
          menuItem: "产业体系",
          menu: [
            {
              dropdownItem: [
                {title: "心智谷", url: "/case"},
                {title: "心理+", url: "/case"},
              ],
            }
          ],
        },
        {
          index: "/goin",
          menuItem: "业务体系",
          menu: [
            {
              dropdownItem: [
                {title: "天网--心理健康智慧云平台建设", url: "/goin"},
                {title: "地网--心理服务物理空间建设" + '\xa0\xa0\xa0', url: "/goin"},
                {title: "人网--人才培养与人才选拔" + '\xa0\xa0\xa0\xa0\xa0\xa0', url: "/goin"},
                {title: "和网--心理健康专业服务" + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0', url: "/goin"},
              ],
            }
          ],
        },
        {
          index: "/download",
          menuItem: "心闻资讯",
          menu: [
            {
              dropdownItem: [
                {title: "参观指导", url: "/download"},
                {title: "前沿动态", url: "/download"},
                {title: "学术交流", url: "/download"},
                {title: "实践在线", url: "/download"},
                {title: "关心关爱", url: "/download"},
                {title: "信息发布", url: "/download"},
              ],
            }
          ],
        },
      ],
      width: document.documentElement.clientWidth,
    };
  },
  created() {
    //在窗口滚动时调用监听窗口滚动方法
    window.addEventListener('scroll', this.windowScrollListener);
    getOssUrl().then(res => {
      Vue.prototype.imgserver = 'http://' + res.data.data
    })
  },
  watch: {
    '$route.path'(now, old) {
      this.defaultActive = now
      if (now == '/') {
        this.logo = false
      } else {
        this.logo = true
      }
      if (now == '/earthDetail' || now == '/mentally' || now == '/physics') {
        this.defaultActive = '/goin'
      }
      if (now == '/consultationDetails') {
        this.defaultActive = '/download'
      }
      if (now == '/productdetail') {
        this.defaultActive = '/product'
      }
    },
  },
  mounted() {
    let that = this
    getSite().then(res => {
      console.log(res,'rrrrr');
      this.list = res.data.data
      this.contactList[0].content = this.list.address
      this.contactList[1].content = this.list.phone
      this.contactList[2].content = this.list.marketHotLine

    })
    document.addEventListener('click', function (e) {
      // console.log(e)
      if (e.target.id !== 'clickQuery') {
        that.menuShow = false
      }
    })
    window.onresize = () => {
      return (() => {
        this.width = document.documentElement.clientWidth // 宽
      })()
    }
    if (this.$route.path == '/earthDetail') {
      this.defaultActive = '/goin'
    } else if (this.$route.path == '/mentally') {
      this.defaultActive = '/goin'
    } else if (this.$route.path == '/physics') {
      this.defaultActive = '/goin'
    } else if (this.$toute.path == '/productdetail') {
      this.defaultActive = '/product'
    }

  },
  methods: {
    handleClick() {
      this.show3 = true
      if(this.width>=1200){
        gsap.to('.customerBoxes', {
          duration:0.5,
          x: -20,
          opacity: 1
        });
      } else {
        gsap.to('.customerBoxes', {
          duration:0.5,
          x: 0,
          opacity: 1
        });
      }

    },
    handleClicks() {
      this.show3 = false
      gsap.to('.customerBoxes', {
            duration:0.5,
            x: 0,
            opacity: 0
          }

      );
    },

    // onClick(url) {
    //     // window.location.href = url;
    // },
    menuClick() {
      // this.menuShow = true
      if (this.menuShow) {
        this.menuShow = false
      } else {
        this.menuShow = true
      }
    },
    handleSelectMove() {
      this.menuShow = false
    },
    commidClick(a) {
      window.console.log(a, 'aaaaaa');
      this.$router.push({
        path: a.url,
      })
    },
    handleSelect(key) {
      //   this.isShow = this.defaultActive != key;
      this.defaultActive = key
      // window.console.log(this.defaultActive,'keykeykey');
      if (key == '/') {
        this.logo = false
      } else {
        this.logo = true
      }
    },
    //监听窗口滚动
    windowScrollListener() {
      if (this.defaultActive == '/') {
        //获取操作元素最顶端到页面顶端的垂直距离
        var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        console.log(scrollTop, 'scrollTop');
        if (scrollTop >= 680) {
          this.logo = true; //大于680时显示元素
        }
        if (scrollTop < 680) {
          this.logo = false; //小于680时隐藏元素
        }
      }
    }
  }
};
</script>

<style>
/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px; /*  设置纵轴（y轴）轴滚动条 */
  height: 2px; /*  设置横轴（x轴）轴滚动条 */
}
/* 滚动条滑块（里面小方块） */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0,0,0,0.9);
}
/* 滚动条轨道 */
::-webkit-scrollbar-track {
  border-radius: 0;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: transparent;
}

.ql-container.ql-snow {
  border: 1px solid transparent !important;
}

.imgBox {
  margin-top: 10px;
}

.ql-editor {
  white-space: normal !important;
}

.ql-container {
  white-space: pre-wrap !important;
}
.imgcontent{
  width: 80px;
  height: 80px;
}

.imgcontents{
  width: 50px;
  height: 50px;
}

.imgcontents img{
  width: 100%;
  height: 100%;
}

.imgcontent img{
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss">
@import url('./assets/font/font.css');

* {
  margin: 0;
  padding: 0;
  font-family: "Microsoft YaHei";
  // font-size: 20px;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  color: #34A59A !important;
}

::v-deep .el-menu.el-menu--horizontal {
  border-bottom: transparent !important;
}

/* 消除小三角 */
.el-popper[x-placement^=bottom] .popper__arrow {
  border: none;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
  border: none;
}

@media(min-width: 1200px) {
  .viewBox {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    margin: 0 auto;
    position: relative;
    position: fixed;
    z-index: 999;
    color: black;
    // padding: 0 150px;
    box-sizing: border-box;
    font-size: 20px !important;

    .el-dropdown-link {
      color: #fff;
      font-size: 20px;
    }

    .dropdown-sortTitle {
      font-weight: 700;
    }

    .el-menu {
      background-color: transparent;
    }

    .el-menu-item {
      background-color: transparent !important;
      color: #fff !important;
      &:nth-child(6){
        margin: 0 0 0 40px !important;
      }
      // margin:0 40px;
      // padding: 0;
    }

    .el-menu-demo .el-menu--horizontal .el-menu {
      background-color: transparent !important;
      color: #fff !important;
    }

    .el-menu--horizontal > .el-menu-item {
      color: #fff !important;
    }

    .el-menu.el-menu--horizontal {
      border-bottom: none !important;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom: 2px solid #fff !important;
      background-color: transparent;
      color: #fff !important;
      font-weight: 700;
    }

    .el-menu--horizontal > .el-menu-item {
      height: 60px !important;
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      margin: 0 40px;
      padding: 0;
      line-height: 60px;
    }

    .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
      background-color: transparent;
    }

    .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
      background-color: transparent !important;
    }

    .logo {
      width: 120px;
      padding-top: 8px;
      box-sizing: border-box;
      height: 54px;

      img {
        width: 100%;
        height: 100%;
      }
    }

  }
  .viewBoxs {
    height: 60px;
    font-size: 20px !important;
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    margin: 0 auto;
    position: absolute;
    position: fixed;
    z-index: 999;
    color: black;
    // padding: 0 150px;
    box-sizing: border-box;
    background-color: #fff;

    .el-dropdown-link {
      color: black;
      font-size: 20px;
    }

    .el-menu.el-menu--horizontal {
      border-bottom: transparent !important;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
      font-weight: 700;
      border-bottom: 2px solid #34A59A !important;
    }

    .el-menu--horizontal > .el-menu-item {
      height: 60px !important;
      line-height: 60px;
      color: #333333;
      font-size: 18px;
      font-weight: 500;
      padding: 0;
      margin: 0 40px;
    }

    .logo {
      width: 120px;
      padding-top: 8px;
      box-sizing: border-box;
      height: 54px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.el-main {
  padding: 0 !important;
  overflow: hidden !important;
}

::v-deep .el-menu-item:hover .dropdown {
  display: block !important;
}

@media(max-width: 1200px) {
  .sviewBox {
    width: 100%;
    height: 50px;
    line-height: 50px;
    position: relative;
    position: fixed;
    z-index: 999;
    box-sizing: border-box;
    padding: 10px 20px;
    // background-color: #fff;
    display: flex;
    justify-content: space-between;

    img {
      width: 70px;
      height: 26px;
    }

    .img {
      height: 24;
      width: 24px;
      // z-index: 999;
    }
  }
}
</style>
